<template>
	<div>
		<template v-for="item in faqItems">
			<v-subheader>{{ item.group }}</v-subheader>
			<v-expansion-panel elevation-0>
				<template v-for="i in item.items">
					<v-expansion-panel-content>
						<div slot="header">
							<div>{{ i.title }}</div>
						</div>
						<v-card>
							<v-card-text class="grey lighten-5" v-html="i.message">
							</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</template>
			</v-expansion-panel>
		</template>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        faqItems: []
      };
    },
	methods: {
      async load() {
        try {
          const response = await this.$http.get(
            `/support/faq`,
            {headers: { Authorization: `Bearer ${this.$store.state.auth.token}` }}
            );
          this.faqItems = response.data;
        } catch (error) {
          return this.state = 'invalid';
        }
	  }
	},
	created(){
	  this.load();
	}
  };
</script>
